import React from 'react';
import styles from './AcceptanceStatusesCountView.module.scss';
import useHousesCountByAcceptanceStage from '../../../../../../hooks/useHousesCountByAcceptanceStage';
import IndicatorBadge from '../../../../../../components/common/IndicatorBadge/IndicatorBadge';
import { generateExpWithNum } from '../../../../../../utils/generateExpWithNum';
import { declensions } from '../../../../../../constants/declensions';

const AcceptanceStatusesCountView = ({
  acceptanceStatuses = [],
  gridData = [],
}) => {
  const statusesWithCount = useHousesCountByAcceptanceStage(
    acceptanceStatuses,
    gridData
  );

  return (
    <div className={styles.root}>
      {statusesWithCount?.map((status) => (
        <div className={styles.item}>
          {status?.bg && (
            <IndicatorBadge
              bgColor={status.bg}
              isSquare
            />
          )}
          <div className={styles.text}>
            <span>{status?.value}</span>
            <span className={styles.count}>
              {generateExpWithNum(status.count, declensions.room)}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AcceptanceStatusesCountView;
